// extracted by mini-css-extract-plugin
export var sliderRange = "_rj-2";
export var sliderRoot = "_rj-0";
export var sliderThumb = "_rj-3";
export var sliderTrack = "_rj-1";